export class DeleteBySectorAndIntervalUseCase{
  constructor(repository){
    this.repository=repository
  }

  async execute(ID_SECTOR,START,END=null){
    if(START && END){
      return await this.repository.deleteByIdSectorAndInterval(ID_SECTOR,START,END)
    }
    return await this.repository.deleteByIdSectorAndTime(ID_SECTOR,START)
  }
}
